"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllPromos = exports.getAllBounties = exports.getAllCategories = exports.deleteFavoriteCategory = exports.addFavoriteCategory = exports.deleteFavoriteCategoryWatcher = exports.addFavoriteCategoryWatcher = exports.getAllPromosWatcher = exports.getAllBountiesWatcher = exports.getAllCategoriesWatcher = exports.articlesWatchers = void 0;
var effects_1 = require("redux-saga/effects");
var actions = __importStar(require("./articlesActions"));
var api = __importStar(require("./articlesApi"));
exports.articlesWatchers = [
    getAllCategoriesWatcher,
    getAllBountiesWatcher,
    addFavoriteCategoryWatcher,
    deleteFavoriteCategoryWatcher,
    getAllPromosWatcher
];
function getAllCategoriesWatcher() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(actions.getAllCategories.TRIGGER, getAllCategories)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports.getAllCategoriesWatcher = getAllCategoriesWatcher;
function getAllBountiesWatcher() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(actions.getAllBounties.TRIGGER, getAllBounties)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports.getAllBountiesWatcher = getAllBountiesWatcher;
function getAllPromosWatcher() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(actions.getAllPromos.TRIGGER, getAllPromos)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports.getAllPromosWatcher = getAllPromosWatcher;
function addFavoriteCategoryWatcher() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(actions.addFavoriteCategory.TRIGGER, addFavoriteCategory)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports.addFavoriteCategoryWatcher = addFavoriteCategoryWatcher;
function deleteFavoriteCategoryWatcher() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(actions.deleteFavoriteCategory.TRIGGER, deleteFavoriteCategory)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports.deleteFavoriteCategoryWatcher = deleteFavoriteCategoryWatcher;
function addFavoriteCategory(_a) {
    var serverResponse;
    var payload = _a.payload;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, api.addFavoriteCategory(payload)];
            case 1:
                serverResponse = _b.sent();
                if (!(serverResponse.status == 200)) return [3 /*break*/, 3];
                return [4 /*yield*/, (0, effects_1.put)(actions.addFavoriteCategory.success(serverResponse.data))];
            case 2:
                _b.sent();
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, (0, effects_1.put)(actions.addFavoriteCategory.failure())];
            case 4:
                _b.sent();
                _b.label = 5;
            case 5: return [2 /*return*/];
        }
    });
}
exports.addFavoriteCategory = addFavoriteCategory;
function deleteFavoriteCategory(_a) {
    var serverResponse;
    var payload = _a.payload;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, api.deleteFavoriteCategory(payload)];
            case 1:
                serverResponse = _b.sent();
                if (!(serverResponse.status == 200)) return [3 /*break*/, 3];
                return [4 /*yield*/, (0, effects_1.put)(actions.deleteFavoriteCategory.success(serverResponse.data))];
            case 2:
                _b.sent();
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, (0, effects_1.put)(actions.deleteFavoriteCategory.failure())];
            case 4:
                _b.sent();
                _b.label = 5;
            case 5: return [2 /*return*/];
        }
    });
}
exports.deleteFavoriteCategory = deleteFavoriteCategory;
function getAllCategories() {
    var cache, serverResponse, _a, _b, responseData_1;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                cache = localStorage.getItem('trybe_categories');
                if (!cache) return [3 /*break*/, 2];
                return [4 /*yield*/, (0, effects_1.put)(actions.getAllCategories.success(JSON.parse(cache)))];
            case 1:
                _c.sent();
                return [3 /*break*/, 9];
            case 2:
                _a = effects_1.all;
                return [4 /*yield*/, api.getAllCategories(1)];
            case 3:
                _b = [
                    _c.sent()
                ];
                return [4 /*yield*/, api.getAllCategories(2)];
            case 4: return [4 /*yield*/, _a.apply(void 0, [_b.concat([
                        _c.sent()
                    ])])];
            case 5:
                serverResponse = _c.sent();
                responseData_1 = [];
                serverResponse.forEach(function (_a) {
                    var data = _a.data;
                    responseData_1 = __spreadArray(__spreadArray([], responseData_1, true), data, true);
                });
                if (!responseData_1) return [3 /*break*/, 7];
                return [4 /*yield*/, (0, effects_1.put)(actions.getAllCategories.success(responseData_1))];
            case 6:
                _c.sent();
                return [3 /*break*/, 9];
            case 7: return [4 /*yield*/, (0, effects_1.put)(actions.getAllCategories.failure(serverResponse[0]))];
            case 8:
                _c.sent();
                _c.label = 9;
            case 9: return [2 /*return*/];
        }
    });
}
exports.getAllCategories = getAllCategories;
function getAllBounties() {
    var cache, serverResponse, _a, responseData_2;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                cache = localStorage.getItem('loop_bounties');
                if (!cache) return [3 /*break*/, 2];
                return [4 /*yield*/, (0, effects_1.put)(actions.getAllBounties.success(JSON.parse(cache)))];
            case 1:
                _b.sent();
                return [3 /*break*/, 8];
            case 2:
                _a = effects_1.all;
                return [4 /*yield*/, api.getAllBounties(1)];
            case 3: return [4 /*yield*/, _a.apply(void 0, [[
                        _b.sent()
                    ]])];
            case 4:
                serverResponse = _b.sent();
                responseData_2 = [];
                serverResponse.forEach(function (_a) {
                    var data = _a.data;
                    responseData_2 = __spreadArray(__spreadArray([], responseData_2, true), data, true);
                });
                if (!responseData_2) return [3 /*break*/, 6];
                return [4 /*yield*/, (0, effects_1.put)(actions.getAllBounties.success(responseData_2))];
            case 5:
                _b.sent();
                return [3 /*break*/, 8];
            case 6: return [4 /*yield*/, (0, effects_1.put)(actions.getAllBounties.failure(serverResponse[0]))];
            case 7:
                _b.sent();
                _b.label = 8;
            case 8: return [2 /*return*/];
        }
    });
}
exports.getAllBounties = getAllBounties;
function getAllPromos() {
    var serverResponse;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.getAllPromosData()];
            case 1:
                serverResponse = _a.sent();
                if (!serverResponse.data) return [3 /*break*/, 3];
                return [4 /*yield*/, (0, effects_1.put)(actions.getAllPromos.success(serverResponse.data))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, (0, effects_1.put)(actions.getAllPromos.failure(serverResponse))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [2 /*return*/];
        }
    });
}
exports.getAllPromos = getAllPromos;
